// src/components/cells/CompCodeWithNameCell.tsx
import React from "react";
import { Tooltip } from "@mantine/core";

export interface CompCodeWithNameCellProps {
  compCode?: string | null;
  name?: string | null;
  tooltipFallback?: string;
}

export const CompCodeName: React.FC<CompCodeWithNameCellProps> = ({
  compCode,
  name,
  tooltipFallback = "No name",
}) => {
  const code = compCode ?? "";
  const label = name ?? "";

  return (
    <Tooltip label={label || tooltipFallback} position="top" withArrow withinPortal openDelay={300}>
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
        <span>{code}</span>
        {label && <span style={{ fontSize: 11, color: "#868e96", marginTop: 2 }}>{label}</span>}
      </div>
    </Tooltip>
  );
};
